import React from 'react';
import { StatusMeta } from '../../utils/pro';
interface StatusChipProps {
  meta: StatusMeta;
  /** Adds a leading dot — useful in dense tables where colour alone is subtle. */
  withDot?: boolean;
}
export function StatusChip({
  meta,
  withDot = true
}: StatusChipProps) {
  return <span className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-semibold ${meta.chip}`} data-id="element-202" data-mp="13nq2ad7tavj3">
      {withDot && <span className={`h-1.5 w-1.5 rounded-full ${meta.dot}`} aria-hidden data-id="element-203" data-mp="zjs1zz6r3eog" />}
      {meta.label}
    </span>;
}